/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OccupationState {
    Vacant = 0,
    Occupied = 1,
    Selected = 2,
}
